import { useNavigate, useLocation } from 'react-router-dom';
import { MapIcon } from '@heroicons/react/16/solid';
import GeneGeneralInfo from '../GeneContent/GeneGeneralInfo';
import GeneSynonyms from '../GeneContent/GeneSynonyms';
import CollapsibleSection from './CollapsibleSection';
import { useMappingStackStore } from '../../store/mappingStackStore';
import { MAPPING_URL_PARAM, encodeMappingStateForUrl } from '../../utils/mappingUrlState';
import { getRowGeneNcbiId } from '@/utils/geneNcbiId';

export function getKeyName(baseName, number = '') {
  return `${baseName}${number}`;
}

export default function DetailGene({ values }) {
  const navigate = useNavigate();
  const location = useLocation();
  const geneSymbol: string | undefined = values?.symbol;
  const geneNcbiId = getRowGeneNcbiId(values);
  const mappingState = useMappingStackStore.getState();
  const serializableStackSnapshot = mappingState.stack.map(level => ({
    ...level,
    labelNode: undefined,
  }));
  const fromSearchParams = new URLSearchParams(location.search);
  if (mappingState.stack.length > 1 && mappingState.currentIndex > 0) {
    fromSearchParams.set(
      MAPPING_URL_PARAM,
      encodeMappingStateForUrl({
        stack: serializableStackSnapshot,
        currentIndex: mappingState.currentIndex,
        tableStateByLevelId: mappingState.tableStateByLevelId,
      }),
    );
  }

  return (
    <div className="space-y-0">
      <CollapsibleSection title="General Info" defaultOpen>
        <div className="p-2">
          <GeneGeneralInfo geneDetailInfo={values} />
        </div>
      </CollapsibleSection>
      <CollapsibleSection title="Synonyms" defaultOpen>
        <div className="p-2">
          <GeneSynonyms geneDetailInfo={values} />
        </div>
      </CollapsibleSection>
      {geneSymbol && (
        <div className="px-3 py-3 border-t border-gray-100">
          <button
            type="button"
            onClick={() =>
              navigate(
                `/gene-pathways?symbol=${encodeURIComponent(geneSymbol)}${geneNcbiId != null ? `&id=${encodeURIComponent(geneNcbiId)}` : ''}`,
                {
                  state: {
                    from: {
                      pathname: location.pathname,
                      search: `?${fromSearchParams.toString()}`,
                      hash: location.hash,
                    },
                  },
                },
              )
            }
            className="flex items-center gap-2 text-sm font-medium text-emerald-700 hover:text-emerald-900 hover:bg-emerald-50 rounded-md px-2 py-1.5 transition-colors w-full"
          >
            <MapIcon className="w-4 h-4 flex-shrink-0" />
            View Pathways
          </button>
        </div>
      )}
    </div>
  );
}
